import classNames from 'classnames';
import { StylishNewRadio } from 'components/DesignSystems/New/StylishNewRadio';
import React from 'react';
import { Controller, RegisterOptions, useFormContext } from 'react-hook-form';

type FormRadioFieldProps = {
  title: string;
  fieldName: string;
  options: string[];
  rules?:
    | { [key: string]: { value: unknown; message: string } }
    | RegisterOptions;
  variant?: 'full' | 'half';
  disabled?: boolean;
  className?: string;
};

const FormRadioField: React.FC<FormRadioFieldProps> = ({
  title,
  fieldName,
  options,
  rules,
  variant = 'full',
  disabled,
  className,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const required = typeof rules?.required === 'object';

  return (
    <div
      className={classNames('mt-2', {
        'col-6': variant === 'half',
        'col-12': variant === 'full',
      })}
    >
      <label className="form-label">
        {title}
        {required ? (
          <span aria-label="Required field" className="required">
            *
          </span>
        ) : null}
      </label>
      <Controller
        control={control}
        name={fieldName}
        rules={rules}
        render={({ field: { onChange, value } }) => (
          <div className={className}>
            {options.map((option, i: number) => (
              <div key={i} className="mb-1">
                <StylishNewRadio
                  label={option}
                  checked={value === option}
                  onChange={() => {
                    onChange(option);
                  }}
                  key={i}
                  value={option}
                  id={i}
                  name={fieldName}
                  className=""
                  disabled={disabled}
                />
              </div>
            ))}
          </div>
        )}
      />
      {errors[fieldName] ? (
        <div className="form-text form-error">
          {errors[fieldName].message as string}
        </div>
      ) : (
        <div className="form-text-none"></div>
      )}
    </div>
  );
};

export default FormRadioField;
